export default (results) => {
    return new Promise((resolve) => {
        setTimeout( () => {
            resolve(1);
        }, 100)
    })
}